import text from './text';
import echarts from "./echarts";
import layout from './layout';
import map from './map';
import complex from './complex';
import { components as basic } from "./basic";
import { components as background } from "./background";
import { functions } from "./functions";
import {datasets} from './datasets';

const components = [
  ...text,
  ...echarts,
  ...layout,
  ...map,
  ...complex,
  ...basic,
  ...background
];

const defaultPropEditor = 'de-common-prop-editor';
const name = '预定义组件库';
export {
  name,
  components,
  defaultPropEditor,
  datasets,
  functions
}